import { createFileRoute } from "@tanstack/react-router";

import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/shared/ui/card";
import { WebLayout } from "@/web/layout/web-layout";

export const Route = createFileRoute("/_web/support")({
  component: SupportPage,
});

function SupportPage() {
  return (
    <WebLayout>
      <div className="flex justify-center py-12">
        <Card className="w-full max-w-2xl">
          <CardHeader>
            <CardTitle>Customer Support</CardTitle>
          </CardHeader>
          <CardContent variant="space4">
            <p>
              Our support team is here to help you get the
              most out of our API intermediation service.
              Whether you need technical assistance, have
              questions about integrations, or need help
              with account management, we're ready to assist
              you.
            </p>

            <div className="rounded-lg border p-4 text-center">
              <h3 className="mb-2 text-lg font-medium">
                📧 Contact Support
              </h3>
              <p className="font-medium text-info-foreground">
                gabriel.ecegi@blogic.cz
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
    </WebLayout>
  );
}
